module.exports = __webpack_public_path__ + "img/ic-calendar-copy-30.9ce88b75.svg";